export const SITE = {
  name: 'IšgerkVaistus',
  url: process.env.REACT_APP_SITE_URL || 'https://sarunashelse.live',
  contactEmail: process.env.REACT_APP_CONTACT_EMAIL || 'sarunashelse@gmail.com',
  facebookUrl: 'https://www.facebook.com/isgerkvaistus/',
  privacyUrl: '/privacy',
  termsUrl: '/terms',
  googlePlayUrl: (process.env.REACT_APP_GOOGLE_PLAY_URL || '').trim(),
  plans: {
    monthlyPrice: '1,99 €/mėn.',
    yearlyPrice: '19,99 €/metus.',
    subscribeMonthly: 'Mėnesinis – €1,99/mėn',
    subscribeYearly: 'Metinis – €19,99/metus',
  },
  trialDays: 7,
};

export function hasGooglePlayUrl() {
  return Boolean(SITE.googlePlayUrl);
}
